<div class="responsive-card">
  <span class="responsive-card-title" i18n> {{ jurisdictionId | governingJurisdictionName }} Spousal Waiver </span>
  <div class="d-flex flex-column" [style.gap.rem]="2.5" *ngIf="!!waivers?.length; else empty">
    <ng-container *ngFor="let waiver of waivers; trackBy: trackById">
      <div class="d-flex flex-column gap-4">
        <app-file-list-item
          [fileLabel]="waiver.waiverTypeId | spousalWaiverTypeLabel"
          [fileName]="waiver.attachment.fileName"
          [fileSizeInBytes]="waiver.attachment.fileSize"
          [previewUrl]="waiver.attachment.links | attachmentLink"
          action="download" />
        <div class="review-entry-grid">
          <app-review-entry label="Date Signed" i18n-label [value]="waiver.signedDate | date : 'MMM d, yyyy'" />
          <app-review-entry label="Effective Date" i18n-label [value]="waiver.effectiveDate | date : 'MMM d, yyyy'" />
        </div>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #empty>
  <div class="empty-text" i18n>A spousal waiver wasn’t included in the submission.</div>
</ng-template>
